import { Injectable } from '@angular/core';
import { isValid } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class DateConverterService {

  constructor() { }
  convertDate(date: Date | string): Date {
    if (!date) {
      return null;
    }

    if (typeof date === 'string') {
      date = new Date(date);
      if (!isValid(date)) {
        throw new Error('Date is not valid');
      }
    }

    date.getTimezoneOffset() < 0
      ? date.setTime(date.getTime() - date.getTimezoneOffset() * 60000)
      : date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);

    return date;
  }
}
